var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 687,
    height: 254,
    viewBox: "0 0 687 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2768_19323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.339 241.428C561.259 239.349 563.264 237.438 565.326 237.603C567.389 237.768 569.061 239.976 568.648 242.003C569.179 240.394 571.349 239.671 572.836 240.479C574.324 241.288 574.937 243.301 574.343 244.879C573.749 246.458 572.13 247.547 570.444 247.714C571.064 247.414 571.754 247.286 572.441 247.345C573.128 247.404 573.786 247.648 574.346 248.05C576.114 249.356 576.381 251.853 576.494 254.05H561.336L561.339 241.428Z",
    fill: "#89AF5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.367 238.465C550.367 238.465 554.19 225.309 558.678 227.771C561.428 229.286 558.771 237.726 556.813 237.525C556.813 237.525 561.329 234.692 563.523 236.936C566.273 239.739 563.523 243.055 563.523 243.055C563.523 243.055 569.169 242.252 570.915 245.83C572.802 249.699 566.886 254.08 566.886 254.08H550.367V238.465Z",
    fill: "#A1C180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.663 241.428C125.743 239.349 123.738 237.438 121.676 237.603C119.613 237.768 117.941 239.976 118.354 242.003C117.823 240.394 115.653 239.671 114.165 240.479C112.678 241.288 112.064 243.301 112.658 244.879C113.252 246.458 114.872 247.547 116.558 247.714C115.938 247.414 115.247 247.286 114.56 247.345C113.874 247.404 113.215 247.648 112.656 248.05C110.887 249.356 110.621 251.853 110.508 254.05H125.666L125.663 241.428Z",
    fill: "#89AF5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.63 238.465C136.63 238.465 132.808 225.309 128.32 227.771C125.57 229.286 128.226 237.726 130.184 237.525C130.184 237.525 125.669 234.692 123.474 236.936C120.724 239.739 123.474 243.055 123.474 243.055C123.474 243.055 117.829 242.252 116.082 245.83C114.196 249.699 120.111 254.08 120.111 254.08H136.63V238.465Z",
    fill: "#A1C180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.974 114.559H413.461V254.072H552.974V114.559Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.803 110.274H406.316C403.725 110.274 401.625 112.375 401.625 114.966C401.625 117.557 403.725 119.657 406.316 119.657H554.803C557.394 119.657 559.494 117.557 559.494 114.966C559.494 112.375 557.394 110.274 554.803 110.274Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.969 185.501H542.906V127.462H511.969V185.501Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.781 185.501H500.719V127.462H469.781V185.501Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.602 185.501H458.539V127.462H427.602V185.501Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.584 129.252H428.555V183.71H457.584V129.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.771 129.252H470.742V183.71H499.771V129.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.967 129.252H512.938V183.71H541.967V129.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.969 246.284H542.906V188.245H511.969V246.284Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.781 246.284H500.719V188.245H469.781V246.284Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.602 246.284H458.539V188.245H427.602V246.284Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.584 190.033H428.555V244.491H457.584V190.033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.771 190.033H470.742V244.491H499.771V190.033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.967 190.033H512.938V244.491H541.967V190.033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.026 254.069L273.539 254.069V114.556L134.026 114.556L134.026 254.069Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.197 119.657L280.684 119.657C283.275 119.657 285.375 117.557 285.375 114.966C285.375 112.375 283.275 110.274 280.684 110.274L132.197 110.274C129.606 110.274 127.506 112.375 127.506 114.966C127.506 117.557 129.606 119.657 132.197 119.657Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.461 185.501H259.398V127.462H228.461V185.501Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.416 183.71H258.445V129.252H229.416V183.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.281 185.501H217.219V127.462H186.281V185.501Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.229 183.71H216.258V129.252H187.229V183.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.094 185.501H175.031V127.462H144.094V185.501Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.461 246.284H259.398V188.245H228.461V246.284Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.281 246.284H217.219V188.245H186.281V246.284Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.094 246.284H175.031V188.245H144.094V246.284Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.034 183.71H174.062V129.252H145.034V183.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.416 244.494H258.445V190.035H229.416V244.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.229 244.494H216.258V190.035H187.229V244.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.034 244.494H174.062V190.035H145.034V244.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.668 4.62207H283.328V114.559H403.668V4.62207Z",
    fill: "#E35B42"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M320.038 18.3916H293.93V55.3076H320.038V18.3916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M320.038 63.4668H293.93V100.383H320.038V63.4668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M356.554 18.3916H330.445V55.3076H356.554V18.3916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M356.554 63.4668H330.445V100.383H356.554V63.4668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M393.062 18.3916H366.953V55.3076H393.062V18.3916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M393.062 63.4668H366.953V100.383H393.062V63.4668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.815 20.124H295.156V53.575H318.815V20.124Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.817 65.1992H295.156V98.6502H318.817V65.1992Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.301 -0.0693359H281.699C279.108 -0.0693359 277.008 2.03112 277.008 4.62216C277.008 7.21321 279.108 9.31366 281.699 9.31366H405.301C407.892 9.31366 409.992 7.21321 409.992 4.62216C409.992 2.03112 407.892 -0.0693359 405.301 -0.0693359Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.815 20.4482V25.885L295.156 41.7112V36.269L318.815 20.4482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.815 32.5293V36.1621L295.156 51.9828V48.3556L318.815 32.5293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.815 66.1592V71.5959L295.156 87.4222V81.9799L318.815 66.1592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.815 78.2368V81.8696L295.156 97.6903V94.0658L318.815 78.2368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.322 20.124H331.664V53.575H355.322V20.124Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.325 65.1992H331.664V98.6502H355.325V65.1992Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.322 20.4482V25.885L331.664 41.7112V36.269L355.322 20.4482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.322 32.5293V36.1621L331.664 51.9828V48.3556L355.322 32.5293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.322 66.1592V71.5959L331.664 87.4222V81.9799L355.322 66.1592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.322 78.2368V81.8696L331.664 97.6903V94.0658L355.322 78.2368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.838 20.124H368.18V53.575H391.838V20.124Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.841 65.1992H368.18V98.6502H391.841V65.1992Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.841 20.4482V25.885L368.18 41.7112V36.269L391.841 20.4482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.841 32.5293V36.1621L368.18 51.9828V48.3556L391.841 32.5293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.841 66.1592V71.5959L368.18 87.4222V81.9799L391.841 66.1592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.841 78.2368V81.8696L368.18 97.6903V94.0658L391.841 78.2368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.846 114.559H269.156V254.072H417.846V114.559Z",
    fill: "#E35B42"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M376.954 200.018H310.055V254.069H376.954V200.018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.233 195.533H305.767C304.528 195.533 303.523 196.537 303.523 197.777C303.523 199.016 304.528 200.021 305.767 200.021H381.233C382.472 200.021 383.477 199.016 383.477 197.777C383.477 196.537 382.472 195.533 381.233 195.533Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.495 203.587H314.227V254.069H343.495V203.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.505 254.072H372.773V203.591H343.505V254.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.263 231.811C350.318 231.811 351.174 230.955 351.174 229.9C351.174 228.844 350.318 227.988 349.263 227.988C348.207 227.988 347.352 228.844 347.352 229.9C347.352 230.955 348.207 231.811 349.263 231.811Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.739 231.811C338.795 231.811 339.651 230.955 339.651 229.9C339.651 228.844 338.795 227.988 337.739 227.988C336.684 227.988 335.828 228.844 335.828 229.9C335.828 230.955 336.684 231.811 337.739 231.811Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M343.5 186.761C360.396 186.761 374.094 173.063 374.094 156.167C374.094 139.271 360.396 125.573 343.5 125.573C326.604 125.573 312.906 139.271 312.906 156.167C312.906 173.063 326.604 186.761 343.5 186.761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.499 180.845C357.128 180.845 368.177 169.796 368.177 156.167C368.177 142.537 357.128 131.488 343.499 131.488C329.869 131.488 318.82 142.537 318.82 156.167C318.82 169.796 329.869 180.845 343.499 180.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.747 153.982H345.677V146.904C345.677 146.326 345.447 145.771 345.038 145.362C344.629 144.953 344.074 144.724 343.496 144.724C342.918 144.724 342.363 144.953 341.954 145.362C341.545 145.771 341.315 146.326 341.315 146.904V153.975H334.251C333.673 153.975 333.118 154.205 332.709 154.614C332.3 155.023 332.07 155.577 332.07 156.156C332.07 156.734 332.3 157.289 332.709 157.698C333.118 158.107 333.673 158.336 334.251 158.336H341.322V165.407C341.322 165.986 341.552 166.54 341.96 166.949C342.369 167.358 342.924 167.588 343.502 167.588C344.081 167.588 344.635 167.358 345.044 166.949C345.453 166.54 345.683 165.986 345.683 165.407V158.343H352.747C353.326 158.343 353.88 158.113 354.289 157.704C354.698 157.295 354.928 156.741 354.928 156.162C354.928 155.584 354.698 155.029 354.289 154.62C353.88 154.211 353.326 153.982 352.747 153.982Z",
    fill: "#EE3224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.74 110.274H269.254C266.663 110.274 264.562 112.375 264.562 114.966C264.562 117.557 266.663 119.657 269.254 119.657H417.74C420.331 119.657 422.432 117.557 422.432 114.966C422.432 112.375 420.331 110.274 417.74 110.274Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.5 203.587V254.069",
    stroke: "#E0E0E0",
    strokeWidth: 2.41358,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.25 94.9682C687.25 97.4432 684.42 99.4314 680.925 99.4314C679.495 99.45 678.085 99.0853 676.844 98.3754C678.136 95.1002 680.375 92.6252 682.737 90.7002C685.347 91.2502 687.25 92.947 687.25 94.9682Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2768_19323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 687,
    height: 254,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoHospital);
export default __webpack_public_path__ + "static/media/NoHospital.32ba780dbb0b2064ce2b3ae125cf93ae.svg";
export { ForwardRef as ReactComponent };